import type { WardrobeInsights, WardrobeInsightsResponse } from '../../shared/insights';
import { readError } from './api';

export async function getWardrobeInsights(): Promise<WardrobeInsights> {
  const response = await fetch('/api/insights', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(await readError(response));
  return ((await response.json()) as WardrobeInsightsResponse).insights;
}
